/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Segment } from '../../models/segment';

export interface GetSegment$Params {
  id: string;
}

export function getSegment(http: HttpClient, rootUrl: string, params: GetSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<Segment>> {
  const rb = new RequestBuilder(rootUrl, getSegment.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Segment>;
    })
  );
}

getSegment.PATH = '/v0/segments/{id}';
